// Column definitions for the merchant Refunds table. Mirrors the Returns
// table's cell style (caption header + value) so both tabs look consistent.
import {ColumnData} from "../../../../assets/types/ColumnData";
import FaiBox from "../../../../MuiComponents/FaiBox";
import FaiTypography from "../../../../MuiComponents/FaiTypography";

const cell = (index: number) => ({value, row}: any) => (
    <div {...row.getToggleRowExpandedProps()}>
        <FaiBox>
            <FaiTypography variant={"caption"}>{row.cells[index].column.Header}</FaiTypography>
        </FaiBox>
        <FaiBox>
            <FaiTypography variant={"h1"} sx={{fontSize: "14px"}} fontWeight={"medium"}>{value}</FaiTypography>
        </FaiBox>
    </div>
);

const columns: ColumnData[] = [
    {Header: "Product", accessor: "productName", Cell: cell(0)},
    {Header: "Amount", accessor: "amount", Cell: cell(1)},
    {Header: "Destination", accessor: "destination", Cell: cell(2)},
    {Header: "Status", accessor: "status", Cell: cell(3)},
    {Header: "Date", accessor: "date", Cell: cell(4)},
];

const rows: any = [];

const dataTableData = {
    columns,
    rows,
};

export default dataTableData;
